"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useServiceBaysStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../../common/utils/fetch"));
const i18n_1 = __importDefault(require("../../../common/i18n"));
exports.useServiceBaysStore = (0, pinia_1.defineStore)("serviceBaysStore", {
    state: () => ({
        serviceBays: [],
    }),
    getters: {},
    actions: {
        getServiceBays(locationId) {
            this.serviceBays = [];
            if (locationId === undefined) {
                return;
            }
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("/api/get/locations/service-bays/" + locationId, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    //body: JSON.stringify({ userCode: userCode }),
                })
                    .then((response) => {
                    if (typeof response.error !== "undefined") {
                        reject(i18n_1.default.trans("frontend_location_error", "No ServiceBay found!", "frontend"));
                        return;
                    }
                    this.serviceBays = [];
                    response.forEach((item) => {
                        this.serviceBays.push(item);
                    });
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
    },
});
